//Redact urls tracked by the Siteimprove script on Pageloads

// Ensure that the _sz variable is present
window._sz = window._sz || [];

const uuidRegex =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

function removeLanguageRoot(url: string) {
  return url.replace("/nb/", "/").replace("/nn/", "/").replace("/en/", "/");
}

function redactURL(url: string) {
  return removeLanguageRoot(url)
    .split("/")
    .map((part) => (/^\d+$/.test(part) ? "{id}" : part))
    .map((part) => (uuidRegex.test(part) ? "{uuid}" : part))
    .join("/");
}

window.redactSiteImproveUrl = redactURL;

// Overwrite the URL
window._sz.push([
  "url",
  redactURL(window.location.origin + window.location.pathname),
]);

// Overwrite the referrer
if (document.referrer) {
  const ref = new URL(document.referrer);
  window._sz.push(["ref", redactURL(ref.origin + ref.pathname)]);
}
